module.exports = __webpack_public_path__ + "img/landing42.89128b99.jpg";